import React from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';
import CustomSelect from '../../../components/widgets/CustomSelect';

/**
 * 버튼 테마 제어 컴포넌트
 * 원본: button-theme-control.html
 */
const ButtonThemeControl = () => {
  const { themeConfig, set } = useTheme();
  const currentThemeConfig = themeConfig || {};

  return (
    <div style={{ marginBottom: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
        <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px', margin: 0, flex: 1 }}>🔘 버튼 테마:</label>
        <button
          type="button"
          onClick={() => set('buttonTheme', 'btn-theme01')}
          style={{
            background: 'transparent',
            border: '1px solid #ddd',
            color: '#666',
            fontSize: '11px',
            padding: '4px 10px',
            borderRadius: '3px',
            cursor: 'pointer'
          }}
        >
          리셋
        </button>
      </div>
      <CustomSelect
        value={currentThemeConfig.buttonTheme || 'btn-theme01'}
        onChange={(theme) => {
          set('buttonTheme', theme);
          // CSS 파일 동적 로드 (간단한 버전)
          const existingLinks = document.querySelectorAll('link[data-button-theme]');
          existingLinks.forEach(link => link.remove());
          if (theme !== 'btn-theme01') {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = `/assets/css/page/${theme}.css`;
            link.setAttribute('data-button-theme', theme);
            document.head.appendChild(link);
          }
        }}
        isSearchable={false}
        isClearable={false}
        options={[
          { value: 'btn-theme01', label: '버튼 테마 1 (기본)' },
          { value: 'btn-theme02', label: '버튼 테마 2 (라운드 형태)' },
          { value: 'btn-theme03', label: '버튼 테마 3 (플렛 형태)' },
        ]}
        styles={{
          control: (base, state) => ({
            ...base,
            width: '100%',
            minHeight: 34,
            fontSize: 12,
            borderRadius: 4,
            borderColor: state.isFocused ? '#86b7fe' : '#ddd',
          }),
          valueContainer: (base) => ({ ...base, padding: '0 10px' }),
          indicatorsContainer: (base) => ({ ...base, height: 34 }),
        }}
      />
    </div>
  );
};

export default ButtonThemeControl;

